import { Typography, Avatar, DialogContent, Divider, Grid, useMediaQuery } from '@mui/material'
import PropTypes from 'prop-types'
import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import DialogLayout from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.component'
import {
  CLOSE_TYPES,
  SIZES,
} from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.constants'
import { styles as dialogStyles } from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.styles'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'
import { CHECK_IN_STATUSES } from '@hapana/shared/constants/packages.constants'
import { TEXT_EDITOR_NAME, getDateSelectOptions } from './modal-add-edit-note.constants'
import { useAddClientPrivateNote } from './modal-add-edit-note.hooks'
import { styles } from './modal-add-edit-note.styles'
import TextArea from '../../../text-area/text-area.component'

const AddEditNote = ({ siteId, profileImg, description, name, clientId, showEditTitle }) => {
  const { t } = useTranslation(['common', 'checkIn'])
  /* Text editor is for iteration 2 */
  // const [editorValue, setEditorValue] = useState([])
  const addClientPrivateNote = useAddClientPrivateNote()
  const isSmOrHigher = useMediaQuery((theme) => theme.breakpoints.up('sm'))
  const { popDialog } = useDialog()

  // TODO: Search functionality
  const formMethods = useForm({
    defaultValues: { [TEXT_EDITOR_NAME]: description, mode: 'onChange' },
  })

  const onSubmit = ({ text }) => {
    addClientPrivateNote.mutate({
      clientId,
      siteId,
      /* Text editor is for iteration 2 */
      /* text: JSON.stringify(editorValue), */
      text,
      date: new Date(),
    })
  }

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)} style={dialogStyles.form}>
        <DialogLayout
          closeType={isSmOrHigher ? CLOSE_TYPES.ICON : CLOSE_TYPES.TEXT}
          hasBackLabel
          size={SIZES.SM}
          primaryAction={{
            label: t('checkIn:note.saveNote'),
          }}
          {...(isSmOrHigher && {
            secondaryAction: { label: t('common:cancel'), action: popDialog },
          })}
        >
          <DialogContent sx={styles.titleSection}>
            <Typography marginBottom={2} typography="header2">
              {!showEditTitle
                ? t('checkIn:note.title')
                : t('checkIn:alerts.notesAndPropertiesAlerts.editNoteTitle')}
            </Typography>
            <Grid container alignItems="center">
              <Avatar sx={styles.avatar} src={profileImg?.url} alt={name} />
              <Typography marginLeft={1} color="gray.64" typography="header4">
                {name}
              </Typography>
            </Grid>
          </DialogContent>
          <Divider sx={styles.thickDivider} />
          {/* Note type select is for iteration 2 */}
          {/* <DialogContent sx={styles.selectsSection}>
            <Grid container> */}
          {/* <Grid item container xs={12} sm={4} md={6} flex alignItems="center">
                <SvgIcon sx={styles.icon} component={TagIcon} />
                <Typography typography="medium" color="gray.64">
                  {t('checkIn:note.noteType')}
                </Typography>
                <Box marginLeft={1}>
                  <Select
                    variant={SELECT_VARIANTS.GHOST}
                    multiple={false}
                    options={[{ label: 'Other', value: 'other' }]}
                    name="noteType"
                    defaultValue={'General'}
                    disabled={false}
                  />
                </Box>
              </Grid> */}
          {/* Note date select is for iteration 2 */}
          {/* <Grid item container xs={12} sm={8} md={6} alignItems="center">
                <SvgIcon sx={styles.icon} component={CalendarIcon} />
                <Typography typography="medium" color="gray.64">
                  {t('common:date')}
                </Typography>
                <Box marginLeft={1}>
                  <Select
                    variant={SELECT_VARIANTS.GHOST}
                    options={getDateSelectOptions(t)}
                    name={DATE_SELECT_NAME}
                    defaultValue={DATE_SELECT_DEFAULT_VALUE}
                    placeholder={DATE_SELECT_PLACEHOLDER}
                  />
                </Box>
              </Grid> */}
          {/* </Grid>
          </DialogContent> */}
          <Divider />
          <DialogContent sx={styles.editorSection}>
            <TextArea
              name={TEXT_EDITOR_NAME}
              required
              rows={17}
              sx={styles.fillSpace}
              inputStyles={[styles.fillSpace, styles.input]}
            />
            {/* Text editor is for iteration 2 */}
            {/* <TextEditor value={editorValue} setValue={setEditorValue} /> */}
          </DialogContent>
        </DialogLayout>
      </form>
    </FormProvider>
  )
}

AddEditNote.propTypes = {
  siteId: PropTypes.string.isRequired,
  profileImg: PropTypes.shape({
    url: PropTypes.string,
  }).isRequired,
  status: PropTypes.oneOf(Object.values(CHECK_IN_STATUSES)),
  name: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  date: PropTypes.string,
  description: PropTypes.string,
  showEditTitle: PropTypes.bool,
}

export default AddEditNote
